import type { CSSProperties } from 'react';

/**
 * Shared-element transition between a series tile and its detail page: both
 * covers carry the same view-transition name, and the browser morphs one into
 * the other when the route changes (React Router's `viewTransition`).
 * Browsers without the View Transitions API just switch pages.
 */
export function seriesCoverTransition(seriesId: string): CSSProperties {
  return { viewTransitionName: `series-cover-${seriesId}` };
}
